var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.751,
    height: 51.784,
    viewBox: "0 0 59.751 51.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a33{fill:none;}.b33{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M218.988,108.979H216V105h2.988v-1h3.983v1h2.988v3.983h-2.988v2.988h-3.983Z",
    transform: "translate(-191.104 -102.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M28.946,104v34.854H16V106.49A2.489,2.489,0,0,1,18.49,104Z",
    transform: "translate(-16 -102.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M176,328h19.917v2.988H176Z",
    transform: "translate(-156.083 -298.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M404.946,106.49v32.365H392V104h10.456A2.489,2.489,0,0,1,404.946,106.49Z",
    transform: "translate(-345.195 -102.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M222.971,90.988h2.988v3.983h-2.988v2.988h-3.983V94.971H216V90.988h2.988V88h3.983Z",
    transform: "translate(-191.104 -88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M176,328v2.988h19.917V328Z",
    transform: "translate(-156.083 -298.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M225.958,90.988v3.983h-2.988v2.988h-3.983V94.971H216V90.988h2.988V88h3.983v2.988Z",
    transform: "translate(-191.104 -88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M213.942,428.979H200L201,424h11.826Z",
    transform: "translate(-177.096 -382.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M225.958,90.988v3.983h-2.988v2.988h-3.983V94.971H216V90.988h2.988V88h3.983v2.988Z",
    transform: "translate(-191.104 -88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a33",
    d: "M176,328h19.917v2.988H176Z",
    transform: "translate(-156.083 -298.125)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M58.489,24.631h-8.2V16.863A.863.863,0,0,0,49.427,16H20.083a.863.863,0,0,0-.863.863v7.768h-8.2A3.024,3.024,0,0,0,8,27.651V57.859a3.024,3.024,0,0,0,3.021,3.021h17.5l-.518,2.589H25.261a.863.863,0,0,0-.863.863v1.726H20.083a.863.863,0,1,0,0,1.726H47.7a.863.863,0,1,0,0-1.726H45.112V64.332a.863.863,0,0,0-.863-.863H41.487L40.9,60.879H58.489a3.024,3.024,0,0,0,3.021-3.021V27.651A3.024,3.024,0,0,0,58.489,24.631Zm-37.543-6.9H48.564V54.838H20.946ZM9.726,27.651a1.3,1.3,0,0,1,1.295-1.295h8.2V54.838H9.726Zm33.66,37.543v.863H26.124v-.863ZM29.766,63.469l.518-2.589h8.851l.583,2.589Zm30.017-5.61a1.3,1.3,0,0,1-1.295,1.295H11.021a1.3,1.3,0,0,1-1.295-1.295V56.564H59.784Zm0-3.021H50.29V26.357h8.2a1.3,1.3,0,0,1,1.295,1.295Z",
    transform: "translate(-8 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M393.726,480h-.863a.863.863,0,1,0,0,1.726h.863a.863.863,0,1,0,0-1.726Z",
    transform: "translate(-350.573 -429.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M210.589,87.768v1.726a.863.863,0,0,0,.863.863H214.9a.863.863,0,0,0,.863-.863V87.768h1.726a.863.863,0,0,0,.863-.863V83.452a.863.863,0,0,0-.863-.863h-1.726V80.863A.863.863,0,0,0,214.9,80h-3.452a.863.863,0,0,0-.863.863v1.726h-1.726a.863.863,0,0,0-.863.863V86.9a.863.863,0,0,0,.863.863Zm-.863-3.452h1.726a.863.863,0,0,0,.863-.863V81.726h1.726v1.726a.863.863,0,0,0,.863.863h1.726v1.726H214.9a.863.863,0,0,0-.863.863v1.726h-1.726V86.9a.863.863,0,0,0-.863-.863h-1.726Z",
    transform: "translate(-186.423 -73.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M184.631,65.261A8.631,8.631,0,1,0,176,56.631,8.631,8.631,0,0,0,184.631,65.261Zm0-15.535a6.9,6.9,0,1,1-6.9,6.9A6.9,6.9,0,0,1,184.631,49.726Z",
    transform: "translate(-157.876 -44.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M168.863,324.315h17.261a.863.863,0,0,0,.863-.863v-2.589a.863.863,0,0,0-.863-.863H168.863a.863.863,0,0,0-.863.863v2.589A.863.863,0,0,0,168.863,324.315Zm.863-2.589h15.535v.863H169.726Z",
    transform: "translate(-150.739 -287.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M223.768,225.726a.863.863,0,1,0,0-1.726h-6.9a.863.863,0,0,0,0,1.726Z",
    transform: "translate(-193.56 -201.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M199.535,256.863a.863.863,0,0,0-.863-.863H184.863a.863.863,0,0,0,0,1.726h13.809A.863.863,0,0,0,199.535,256.863Z",
    transform: "translate(-165.013 -230.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b33",
    d: "M224.863,288a.863.863,0,1,0,0,1.726h5.178a.863.863,0,1,0,0-1.726Z",
    transform: "translate(-200.697 -258.656)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDocuments);
export default __webpack_public_path__ + "static/media/other_documents.91de003d.svg";
export { ForwardRef as ReactComponent };